import React from "react";
import PageHeader from "@/components/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import SeoPage from "./SeoPage";
import LocalPage from "./LocalPage";
import AdsPage from "./AdsPage";

/**
 * Combined Marketing Tools tab — SEO (Keywords) + Local SEO + Ad Generator.
 * Each tab embeds the dedicated page component so existing wiring keeps working.
 * Note: nested PageHeaders inside the embedded components are intentionally
 * lighter than a top-level one so the page reads naturally.
 */
export default function MarketingPage() {
  return (
    <div data-testid="marketing-page">
      <PageHeader
        eyebrow="Growth"
        title="Marketing Tools"
        description="SEO keyword research, Local SEO and AI-powered ad creative — all in one place."
      />

      <Tabs defaultValue="seo" className="w-full">
        <TabsList className="bg-white border border-slate-200 rounded-sm p-1 h-auto">
          <TabsTrigger data-testid="tab-mkt-seo" value="seo" className="rounded-sm px-4 py-2 data-[state=active]:bg-slate-900 data-[state=active]:text-white">SEO</TabsTrigger>
          <TabsTrigger data-testid="tab-mkt-local" value="local" className="rounded-sm px-4 py-2 data-[state=active]:bg-slate-900 data-[state=active]:text-white">Local SEO</TabsTrigger>
          <TabsTrigger data-testid="tab-mkt-ads" value="ads" className="rounded-sm px-4 py-2 data-[state=active]:bg-slate-900 data-[state=active]:text-white">Ad Generator</TabsTrigger>
        </TabsList>

        <TabsContent value="seo" className="mt-6" data-testid="content-mkt-seo">
          <div className="-mt-2"><SeoPage embedded /></div>
        </TabsContent>
        <TabsContent value="local" className="mt-6" data-testid="content-mkt-local">
          <div className="-mt-2"><LocalPage embedded /></div>
        </TabsContent>
        <TabsContent value="ads" className="mt-6" data-testid="content-mkt-ads">
          <div className="-mt-2"><AdsPage embedded /></div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
